import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const ServiceApiResources = {
  list:  createUrl('services'),
  create:  createUrl('services/create'),
  detail:  createUrl('services'),
  update:  createUrl('services'),
  delete:  createUrl('services'),
  deleteMultiple:  createUrl('services/delete/multiple'),
  deleteAvailability:  createUrl('services/delete/availability'),
  deleteSubcontractor:  createUrl('services/remove/subcontractor'),
  subcontractorStatusChange:  createUrl('services/subcontractor/default'),
  types:  createUrl('services/service-types'),
  changeStatus:  createUrl('services/change/status'),
  changeAttribute:  createUrl('services/change/attribute'),
  addSubcontractor:  createUrl('services/add/subcontractor'),
  copy: createUrl('services/copy'),
  // Import endpoints
  downloadSample: createUrl('services/import/sample'),
  uploadImport: createUrl('services/import/upload'),
  validateImport: createUrl('services/import/validate'),
  executeImport: createUrl('services/import/execute'),
  importStatus: createUrl('services/import/status'),
  importHistory: createUrl('import-history'),
};
